import React from 'react';

type IconProps = {
  className?: string;
};

export const PencilIcon: React.FC<IconProps> = ({ className }) => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M11.2497 5.41676L14.583 8.75009M3.33301 16.6668H6.66634L15.4163 7.91676C15.8584 7.47473 16.1067 6.87521 16.1067 6.25009C16.1067 5.62497 15.8584 5.02545 15.4163 4.58342C14.9743 4.14139 14.3748 3.89307 13.7497 3.89307C13.1246 3.89307 12.525 4.1414 12.083 4.58342L3.33301 13.3334V16.6668Z" stroke="#3E5060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
